import { render, staticRenderFns } from "./todayBarChart.vue?vue&type=template&id=5d04638c"
import script from "./todayBarChart.vue?vue&type=script&lang=js"
export * from "./todayBarChart.vue?vue&type=script&lang=js"
import style0 from "./todayBarChart.vue?vue&type=style&index=0&id=5d04638c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports